import React from 'react'
import { clsx } from 'clsx'

type BadgeVariant = 'mentee' | 'mentor' | 'success' | 'warning' | 'danger' | 'neutral'

interface BadgeProps {
  children: React.ReactNode
  variant?: BadgeVariant
  className?: string
}

const badgeVariants: Record<BadgeVariant, string> = {
  mentee: 'bg-primary-100 text-primary-700',
  mentor: 'bg-accent-100 text-accent-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  neutral: 'bg-gray-100 text-gray-600',
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'neutral', className }) => {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-3.5 py-1.5 rounded-full text-xs font-bold',
        badgeVariants[variant],
        className
      )}
    >
      {children}
    </span>
  )
}

export default Badge
